import { array } from 'fp-ts';
import { Banner, Stack } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithFieldsConfig } from './types';

interface VoucherFormBannerProps extends WithFieldsConfig {
    enterpriseCount: number;
    selectedVouchersCount?: number;
}

export const VoucherFormBanners = ({
    fieldsConfig,
    selectedVouchersCount,
    enterpriseCount,
}: VoucherFormBannerProps) => {
    const isEditForm = selectedVouchersCount != null;

    if ((isEditForm && selectedVouchersCount === 1) || (!isEditForm && enterpriseCount === 1)) {
        return null;
    }

    const editInfoBannerText =
        enterpriseCount > 1 ? TextKey.VoucherBulkEditMultipleProperties : TextKey.VoucherBulkEditSingleProperty;

    return (
        <>
            {fieldsConfig?.lockedFields && array.isNonEmpty(fieldsConfig.lockedFields) ? (
                <Banner
                    variant="warning"
                    primaryText={<LocalizedText textKey={TextKey.VouchersDifferentValuesWarning} />}
                    secondaryText={<LocalizedText textKey={TextKey.VouchersFieldsWithDifferentValuesAreLocked} />}
                />
            ) : null}
            {isEditForm && (
                <Banner
                    variant="info"
                    primaryText={<LocalizedText textKey={editInfoBannerText} />}
                    secondaryText={
                        <Stack spacing="50" vertical>
                            <Stack>
                                <LocalizedText
                                    textKey={TextKey.VouchersCountMessage}
                                    substitutes={{ numberOfVouchers: selectedVouchersCount }}
                                />
                            </Stack>
                            <Stack>
                                <LocalizedText
                                    textKey={TextKey.PropertiesCountMessage}
                                    substitutes={{ numberOfProperties: enterpriseCount }}
                                />
                            </Stack>
                        </Stack>
                    }
                />
            )}
        </>
    );
};
